import { createStore, combineReducers, applyMiddleware } from 'redux'
import userReducer from './user'
import authReducer from './auth'
import thunk from 'redux-thunk'

const reducer = combineReducers({
 userReducer,
 authReducer
})

const store = createStore(
 reducer,
 applyMiddleware(thunk)
)

export default store
